import React, {useState} from 'react'
import { Link } from "gatsby"
import { useForm } from 'react-hook-form';
import moment from "moment";

import IconArrowShortOrange from "../components/icons/IconArrowShortOrange"

export default function FormJobApplication({formId, type, recipient = 'karriere@rekord-fenster.com', locationName = false}) {

    const { register, handleSubmit } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        defaultValues: {},
        resolver: undefined,
        context: undefined,
        criteriaMode: "all",
        shouldFocusError: true,
        shouldUnregister: false,
        shouldUseNativeValidation: true,
        delayError: undefined
    });

    const onSubmit = async (data, form) => {

        const SubmitButton = document.querySelector('button[data-name="SubmitButton"]')
        SubmitButton.disabled = true

        const formData = new FormData();
        formData.append("_timestamp", data._timestamp);
        formData.append("_sentfrom", data._sentfrom);
        formData.append("_type", data._type);
        formData.append("_location_email", data._recipient);
        formData.append("_location", data._location);
        formData.append("salutation", document.getElementById('salutation').value);
        formData.append("name", data.name);
        formData.append("surname", data.surname);
        formData.append("zip", data.zip);
        formData.append("city", data.city);
        formData.append("email", data.email);
        formData.append("phone", data.phone);
        formData.append("message", data.message);
        formData.append("checkbox", data.checkbox);

        if(data.file.length > 0) {

            var total_size = 0

            Array.from(data.file).map((file, index) => {
                if(index < 5) {
                    formData.append("file" + [index], data.file[index])
                    total_size += data.file[index].size
                }
            })

            if(total_size > 20971520) {
                document.getElementById(formId + '_formFileError').classList.remove('opacity-0', 'h-0', 'overflow-hidden')
                document.getElementById(formId + '_formFileError').classList.add('opacity-100', 'h-full', 'overflow-visible', 'p-4')
                setTimeout(
                    function() {
                        document.getElementById(formId + '_formFileError').classList.remove('opacity-100', 'h-full', 'overflow-visible', 'p-4')
                        document.getElementById(formId + '_formFileError').classList.add('opacity-0', 'h-0', 'overflow-hidden')
                        SubmitButton.disabled = false
                    },
                    5000
                )
            }

            const requestOptions = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Raps': 'MYKpIoOKM2WEgw1grHOuJBboyKMA98zv',
                },
                body: formData
            };
    
            await fetch('https://upload.rekord-fenster.com', requestOptions)
            .then(response => response.json())
            .then(response => {

                Array.from(data.file).map((file, index) => {
                    if(index < 5) {
                        formData.delete("file" + [index])
                    }
                })
            
                formData.append("files", response.files);
                sendForm(form, formData, SubmitButton)
            
            })
            .catch(function(error) {
                console.log('There has been a problem with your fetch operation: ', error.message);
            });

        } else {
            sendForm(form, formData, SubmitButton)
        }

    }

    function sendForm(form, formData, SubmitButton) {

        const requestOptions = {
            method: 'POST',
            mode: 'no-cors',
            referrerPolicy: 'no-referrer',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            },
            body: formData
        };

        fetch('https://hooks.zapier.com/hooks/catch/12346812/b0vjeft/', requestOptions).then(function(response) {
            if(response) {
                document.getElementById(formId + '_formSuccess').classList.remove('opacity-0', 'h-0', 'overflow-hidden', 'p-4')
                document.getElementById(formId + '_formSuccess').classList.add('opacity-100', 'h-full', 'overflow-visible', 'p-4')
                setTimeout(
                    function() {
                        document.getElementById(formId + '_formSuccess').classList.remove('opacity-100', 'h-full', 'overflow-visible', 'p-4')
                        document.getElementById(formId + '_formSuccess').classList.add('opacity-0', 'h-0', 'overflow-hidden', 'p-4')
                    },
                    5000
                )
                form.target.reset()
                document.getElementById('fileLabel').innerHTML = ''
                SubmitButton.disabled = false
            }
            throw new Error('Network response was not ok.');
        }).catch(function(error) {
            console.log('There has been a problem with your fetch operation: ', error.message);
        });

    }

    return (
        <form onSubmit={handleSubmit(onSubmit, this)}>
            <input
                type="hidden"
                value={moment().format("DD-MM-YYYY HH:mm:ss")}
                {...register("_timestamp", {})}
            />
            <input
                type="hidden"
                value={typeof window !== 'undefined' ? window.location.href : ''}
                {...register("_sentfrom", {})}
            />
            <input
                type="hidden"
                value={type}
                {...register("_type", {})}
            />
            <input
                type="hidden"
                id="_recipient"
                value={recipient}
                {...register("_recipient", {})}
            />
                <input
                type="hidden"
                id="_location"
                value={locationName}
                {...register("_location", {})}
            />
            <select id="salutation" defaultValue={'DEFAULT'} {...register("salutation", {})}>
               <option value="---" value="DEFAULT">Keine Anrede</option>
               <option value="Frau">Frau</option>
               <option value="Herr">Herr</option>
            </select>
            <div className="md:flex">
                <div className="form-group md:w-1/2 md:pr-6">
                    <label htmlFor="JAname">Vorname</label>
                    <input
                        type="text"
                        id="JAname"
                        placeholder="z.B.: Max"
                        {...register("name", {required: true, min: 3})}
                    />
                </div>
                <div className="form-group md:w-1/2">
                    <label htmlFor="JAsurname">Nachname</label>
                    <input
                        type="text"
                        id="JAsurname"
                        placeholder="z.B.: Mustermann"
                        {...register("surname", {required: true, min: 3})}
                    />
                </div>
            </div>
            <div className="flex">
                <div className="form-group w-3/12 pr-6">
                    <label htmlFor="JAzip">PLZ</label>
                    <input
                        type="number"
                        id="JAzip"
                        placeholder="z.B.: 9500"
                        {...register("zip", {required: true, min: 1000, max: 999999})}
                    />
                </div>
                <div className="form-group w-9/12">
                    <label htmlFor="JAcity">Ort</label>
                    <input
                        type="text"
                        id="JAcity"
                        placeholder="z.B.: Villach"
                        {...register("city", {required: true, min: 3})}
                    />
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="JAemail">E-Mail-Adresse</label>
                <input
                    type="email"
                    id="JAemail"
                    placeholder="z.B.: email@adresse.at"
                    {...register("email", {required: true, pattern: /^\S+@\S+$/i})}
                />
            </div>
            <div className="form-group">
                <label htmlFor="JAphone">Telefon</label>
                <input
                    type="tel"
                    id="JAphone"
                    placeholder="z.B.: 04242 12345"
                    {...register("phone", {required: true, maxLength: 20})}
                />
            </div>
            <div className="form-group">
                <label htmlFor="JAmessage">Nachricht (optional)</label>
                <textarea
                    id="JAmessage"
                    placeholder="Gib hier deine Nachricht ein :)"
                    {...register("message", {})}
                />
            </div>
            <div className="pb-4">
                <div className="form-group-file">
                    <input
                        id="file"
                        type="file"
                        multiple
                        accept=".pdf, .doc, .docx, .odt, .txt, .rtf, .jpeg, .jpg, .png, .tiff, .gif"
                        onInput={(event) => {
                            document.getElementById('fileLabel').innerHTML = event.target.files.length + (event.target.files.length === 1 ? ' Datei' : ' Dateien') + ' ausgewählt'
                        }}
                        {...register("file", {})}
                    />
                    <button type="button" onClick={() => { document.getElementById('file').click() }}>
                        <span>Upload</span>
                        <IconArrowShortOrange h="50" w="50" direction="up" />
                    </button>
                    <label htmlFor="file" id="fileLabel"></label>
                </div>
                <div className="text-xs font-semibold">Max. 5 Dateien und 20MB</div>
            </div>
            <div className="form-group-checkbox pb-6">
                <div className="input-wrapper">
                    <input
                    name="checkbox"
                    type="checkbox"
                    id="JAcheckbox"
                    {...register("checkbox", {required: true})}
                    />
                </div>
                <div className="label-wrapper">
                    <label htmlFor="JAcheckbox">
                        Ja, ich bin einverstanden, dass meine Daten gespeichert und zur Bearbeitung meines Anliegens weiterverwendet werden, und ich habe die <Link to="/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">Datenschutzrichtlinien</Link> von REKORD gelesen und akzeptiert. *
                    </label>
                </div>
            </div>
            <div className="opacity-0 h-0 overflow-hidden w-full bg-rekord-lgreen text-green-700 border border-green-700 rounded-lg transition-all duration-300" id={formId + '_formSuccess'}>
                Vielen Dank für Deine Anfrage! Wir werden diese schnellstmöglich bearbeiten.
            </div>
            <div className="opacity-0 h-0 overflow-hidden w-full bg-red-300 text-red-700 border border-red-700 rounded-lg transition-all duration-300" id={formId + '_formFileError'}>
                Die Dateien überschreiten die maximale Größe von 20 MB.
            </div>
            <button data-name="SubmitButton" className="btn btn-green mt-6" type="submit">Bewerbung abschicken</button>
        </form>
    )

}
